import { render, staticRenderFns } from "./attendPage.vue?vue&type=template&id=8619abf6&scoped=true"
import script from "./attendPage.vue?vue&type=script&lang=js"
export * from "./attendPage.vue?vue&type=script&lang=js"
import style0 from "./attendPage.vue?vue&type=style&index=0&id=8619abf6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8619abf6",
  null
  
)

export default component.exports